import script from "./SafetyInstructionView.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetyInstructionView.vue?vue&type=script&setup=true&lang=js"

import "./SafetyInstructionView.vue?vue&type=style&index=0&id=162ed847&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162ed847"]])

export default __exports__